import i18n from "./i18n"; 

const t = i18n.global.t;

export const fetchWrapper = {
  get: request("GET"),
  post: request("POST"),
  put: request("PUT"),
  delete: request("DELETE"),
  patch: request("PATCH"),
};

function objectToUrlSearchParams(obj: object): string {
  const params = new URLSearchParams();

  for (const key of Object.keys(obj)) {
    const value = (obj as any)[key];

    if (value == null || value == undefined) {
      continue;
    }

    if (Array.isArray(value)) {
      // Se o valor é um array, adicione os elementos corretamente
      value.forEach((item) => {
        params.append(`${key}[]`, item);
      });
    } else {
      // Para outros tipos, adicione normalmente
      params.append(key, value);
    }
  }

  return params.toString();
}

function request(method: string) {
  return async (
    url: string,
    body?: object,
    extraHeaders?: Record<string, any>
  ) => {
    const isFormData = body instanceof FormData;

    // Construa os query params se o método for GET e body for um objeto
    let fullUrl = url;
    if (method === "GET" && body && typeof body === "object") {
      const queryString = objectToUrlSearchParams(body);
      fullUrl = `${url}?${queryString}`;
    }

    const requestOptions: RequestInit = {
      method,
      headers: {
        ...(authHeader() as any),
        ...(extraHeaders || {}),
      },
      body:
        method === "GET" || !body
          ? null
          : isFormData
          ? body
          : JSON.stringify(body),
    };

    if (method === "GET") {
      delete requestOptions.body;
    } else if (!isFormData) {
      requestOptions.headers = {
        ...requestOptions.headers,
        "Content-Type": "application/json",
      };
    }

    // Determine the full URL
    const baseUrl = import.meta.env.VITE_APP_API_URL;
    fullUrl = fullUrl.startsWith("http") ? fullUrl : `${baseUrl}${fullUrl}`;

    if (requestOptions.body) {
      if (isFormData) {
        const entries = Array.from((requestOptions.body as FormData).entries());
      }
    }

    return fetch(fullUrl, requestOptions)
      .then(async (response) => {
        const contentType = response.headers.get("Content-Type");

        if (!response.ok) {
          const errorText = await response.text();
          let parsedError: any = null;

          try {
            parsedError = errorText ? JSON.parse(errorText) : null;
          } catch {
            parsedError = null;
          }

          const errorMessage =
            parsedError?.message ||
            response.statusText;
          return Promise.reject({
            message: errorMessage,
            error: parsedError?.error,
            err: parsedError?.err,
            data: parsedError ?? errorText,
            status: response.status,
          });
        }

        if (contentType?.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") || contentType?.includes("application/vnd.ms-excel")) {
          return response.blob();
        }

        if (contentType?.includes("application/pdf")) {
          return response.blob();
        }

        if (contentType?.includes("application/json")) {
          return response.json();
        }

        return response.text();
      })
      .catch((error) => {
        if (error.message === "Failed to fetch") {
          throw new Error(t("fetchWrapper.notConnectServer"));
        } else if (error.message === "Erro interno no servidor") {
          throw new Error(t("fetchWrapper.internalServerError"));
        }
        throw error;
      });
  };
}

function authHeader() {
  const token = localStorage.getItem("token");
  const isLoggedIn = !!token;
  if (isLoggedIn) {
    return { Authorization: `Bearer ${token}` };
  } else {
    return {};
  }
}
